/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

import ModerateSportsTable from "views/moderate-sports-table";

import TableContainer from "@mui/material/TableContainer";
import { Button, Grid } from "@mui/material";

function SportsEventType({
  filterData,
  handleStepperButtonStatus,
  handleStepData,
  showSportPromosSwitch,
}) {
  const [selectedSportName, setSelectedSportName] = useState("");
  const [advancedView, setAdvancedView] = useState(false);

  function handleAdvancedView(e) {
    e.preventDefault();
    let view = advancedView;
    setAdvancedView(!view);
  }

  return (
    <SoftBox>
      <SoftBox width="80%" textAlign="center" mx="auto" mb={4}>
        <SoftBox mb={1}>
          <SoftTypography variant="h5" fontWeight="regular">
            Now its time to select the Type of Events per Sport you want
          </SoftTypography>
        </SoftBox>
        <SoftTypography variant="body2" fontWeight="regular" color="text">
          Let us know which Type (inPlay/Pregame/Both) in any Sport you want to deliver to you
        </SoftTypography>
      </SoftBox>

      <SoftBox mt={2}>
        <TableContainer id="sports-selected-table">
          <Grid style={{ textAlign: "right", maxWidth: "97% !important", width: "97%" }}>
            <Button onClick={handleAdvancedView}>
              {advancedView ? "Normal View" : "Advanced View"}
            </Button>
          </Grid>
          <ModerateSportsTable
            selectedSport={selectedSportName}
            filterData={filterData}
            handleStepperButtonStatus={handleStepperButtonStatus}
            handleStepData={handleStepData}
            advancedView={advancedView}
            showSportPromosSwitch={showSportPromosSwitch}
          ></ModerateSportsTable>
        </TableContainer>
      </SoftBox>
    </SoftBox>
  );
}

// Typechecking props for the DataTable
SportsEventType.propTypes = {
  filterData: PropTypes.array,
  handleStepperButtonStatus: PropTypes.func,
  handleStepData: PropTypes.func,
  showSportPromosSwitch: PropTypes.bool,
};

export default SportsEventType;
